export function findJobId(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return undefined
  }

  if ('jobId' in obj) {
    return obj.jobId
  }

  let jobId
  Object.keys(obj).forEach(key => {
    if (!jobId) {
      jobId = findJobId(obj[key])
    }
  })

  return jobId
}
